import React from 'react';
import { AreaChart, Area} from 'recharts';

const ChartSocialImpact = ({style, values}) => {
    return (
        <AreaChart
            width={165}
            height={60}
            data={values}
            margin={{
                top: 5,
                right: 0,
                left: 0,
                bottom: 5
            }}
        >
            <Area type="monotone" dataKey="uv" stroke={style.stroke} fill={style.fill} />
            <Area type="monotone" dataKey="pv" stroke={style.stroke_line} fill="transparent" />
      </AreaChart>
    );
}

export default ChartSocialImpact;